module.exports = __webpack_public_path__ + "img/new_1.179dfec8.png";